const JOIN_TEAM = 'JOIN_TEAM';
const JOIN_TEAM_PENDING = 'JOIN_TEAM_PENDING';
const JOIN_TEAM_SUCCESS = 'JOIN_TEAM_SUCCESS';

const START_TIMER           = 'START_TIMER';
const START_TIMER_PENDING   = 'START_TIMER_PENDING';
const START_TIMER_SUCCESS   = 'START_TIMER_SUCCESS';
const START_TIMER_ERROR     = 'START_TIMER_ERROR';

const START_TIMER_SOCKET_SUCCESS = 'START_TIMER_SOCKET_SUCCESS';

const STOP_TIMER = 'STOP_TIMER';
const STOP_TIMER_PENDING = 'STOP_TIMER_PENDING';
const STOP_TIMER_SUCCESS = 'STOP_TIMER_SUCCESS';

const FETCH_TEAM = 'FETCH_TEAM';
const FETCH_TEAM_ERROR = 'FETCH_TEAM_ERROR';
const FETCH_TEAM_PENDING = 'FETCH_TEAM_PEDNING';
const FETCH_TEAM_SUCCESS = 'FETCH_TEAM_SUCESS';

const TIMER_STARTED = 'TIMER_STARTED';
const TIMER_STOPPED = 'TIMER_STOPPED';

const TEAM_NOT_FOUND = 'TEAM_NOT_FOUND';

const CREATE_TEAM = 'CREATE_TEAM';
const CREATE_TEAM_ERROR = 'CREATE_TEAM_ERROR';
const CREATE_TEAM_PENDING = 'CREATE_TEAM_PENDING';
const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';

const ALREADY_JOINED_TEAM = "ALREADY_JOINED_TEAM";

export default {
    JOIN_TEAM,
    JOIN_TEAM_PENDING,
    JOIN_TEAM_SUCCESS,

    START_TIMER,
    START_TIMER_ERROR,
    START_TIMER_PENDING,
    START_TIMER_SUCCESS,

    START_TIMER_SOCKET_SUCCESS,

    STOP_TIMER,
    STOP_TIMER_PENDING,
    STOP_TIMER_SUCCESS,

    FETCH_TEAM,
    FETCH_TEAM_ERROR,
    FETCH_TEAM_PENDING,
    FETCH_TEAM_SUCCESS,

    TIMER_STARTED,
    TIMER_STOPPED,

    TEAM_NOT_FOUND,

    CREATE_TEAM,
    CREATE_TEAM_ERROR,
    CREATE_TEAM_PENDING,
    CREATE_TEAM_SUCCESS,

    ALREADY_JOINED_TEAM,
};



// WEBPACK FOOTER //
// ./src/redux/modules/team/constants.ts